// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5bf3051e] .btn-actions i {\n  padding-right: 0 !important;\n}\n.icon[data-v-5bf3051e] .dot em {\n  margin-top: 0 !important;\n  margin-left: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
